<template>
  <div>
    <top-header></top-header>
    <div class="container">
      <div class="content">
        <div class="aside">
          <ul>
            <li
              v-for="item in menuList"
              :key="item.url"
              :class="path == item.url ? 'active' : ''"
            >
              <router-link :to="item.url">{{ item.label }}</router-link>
            </li>
          </ul>
        </div>
        <div class="main">
          <keep-alive>
            <router-view></router-view>
          </keep-alive>
        </div>
      </div>
    </div>
    <div>
      <cenfooter></cenfooter>
    </div>
  </div>
</template>

<script>
import topHeader from "@/components/home/headears.vue";
import cenfooter from "@/components/home/footers.vue";
export default {
  data() {
    return {
      menuList: [
        {
          url: "/user/collection",
          label: "我的收藏",
        },
        {
          url: "/user/mymsg",
          label: "我的消息",
        },
        {
          url: "/user/basicmsg",
          label: "基本信息",
        },
        {
          url: "/user/queueList",
          label: "栏目排序",
        },
      ],
      path: "",
    };
  },
  created() {
    this.path = this.$route.path;
    if (JSON.parse(sessionStorage.getItem("user"))?.account === "admin") {
      this.menuList.push({
        url: "/user/keywordConfig",
        label: "关键字配置",
      });
      this.menuList.push({
        url: "/user/articleConfig",
        label: "系统推送",
      });
      this.menuList.push({
        url: "/user/medicalFrontierInfo",
        label: "医学前沿信息",
      });
      this.menuList.push({
        url: "/user/rotationNewsSetting",
        label: "轮播图片维护",
      });
      this.menuList.push({
        url: "/user/platformStatistics",
        label: "平台统计",
      });
    }
  },
  updated() {
    this.path = this.$route.path;
  },
  components: {
    topHeader,
    cenfooter,
  },
};
</script>

<style scoped lang="scss">
.container {
  width: 100%;
  padding: 0 10%;
  overflow: auto;

  .content {
    width: 100%;
    min-height: 720px;
    margin: 20px auto 0;
    box-sizing: border-box;
    background-color: #fff;
    padding: 20px;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
  }

  .aside {
    min-width: 180px;
    margin-right: 50px;
    ul li {
      width: 100%;
      height: 40px;
      line-height: 40px;
      text-align: center;
      background-color: #f2f7fa;
      border-radius: 4px;
      margin-bottom: 10px;
      a {
        color: #000;
        display: block;
      }
    }
    .active {
      background-color: #0d6ec4;
      a {
        color: #fff;
        display: block;
      }
    }
  }
  .main {
    width: 100%;
  }
}
</style>
